import { L } from '@execonline-inc/translations';
import { T } from '../../../../../../Translations';

// A course licensed only by a license that hasn't started yet is shown with
// the Unlicensed marker's shape, in teal instead of amber.
//
// Theme colors are plain var() values, so Tailwind opacity modifiers on them (bg-primary/10)
// compile to no CSS (DVLP-8193). Tints mix the token with transparent instead.
export const FUTURE_LICENSE_TINT_CLASSES =
  'bg-[color-mix(in_srgb,var(--primary)_10%,transparent)] text-primary border-[color-mix(in_srgb,var(--primary)_20%,transparent)]';

interface Props {
  startsOn: Date;
}

export function LicenseStarts({ startsOn }: Props) {
  return (
    <T
      kind="License starts <date/>"
      date={<L localizeable={startsOn} format="short-month-day-year" />}
    />
  );
}

export function Starts({ startsOn }: Props) {
  return (
    <T kind="Starts <date/>" date={<L localizeable={startsOn} format="short-month-day-year" />} />
  );
}
